import { ConfigService } from "@/api/config"
import type { AppConfig } from "@/models"
import { reactive } from "vue"

const rawConfig = await new ConfigService().get()

const config: AppConfig = reactive(rawConfig)
document.title = config.appName

export function useAppConfig(): AppConfig {
	return config
}
